import { render, staticRenderFns } from "./df-page-account-coupon.vue?vue&type=template&id=3681846a&scoped=true"
import script from "./df-page-account-coupon.ts?vue&type=script&lang=js&external"
export * from "./df-page-account-coupon.ts?vue&type=script&lang=js&external"
import style0 from "./df-page-account-coupon.vue?vue&type=style&index=0&id=3681846a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681846a",
  null
  
)

export default component.exports